"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Validators = void 0;
const isEmpty_1 = require("../../utils/isEmpty");
/**
 * Checks if a mandatory value isn't null/undefined/empty , returns {required:true} if error, return null if it's not null/undefined/empty
 * @param value Value to test
 */
const Required = (value) => {
    if (isEmptyValue(value)) {
        return Promise.resolve({ required: true });
    }
    return Promise.resolve(null);
};
/**
 * Checks if a provided value has the minimum length, returns {minlength:true} if error, return null if value has the minimum length
 * @param value Value to test
 */
const MinLength = (minlength) => {
    if (minlength === 0) {
        console.warn('Validator minlength can not be 0, use the required Validator instead');
    }
    return (value) => {
        if (value && (minlength <= value.length || Object.getPrototypeOf(value) === Object.prototype)) {
            return Promise.resolve(null);
        }
        return Promise.resolve({ minlength: true });
    };
};
/**
 * Checks if a provided value has the maxLength
 * return { maxLength: true } when value is bigger maxLenght
 * return null when value is valid.
 * @param value Value to test
 */
const MaxLength = (maxLength) => {
    if (maxLength === 0) {
        throw 'Validator maxLength can not be 0';
    }
    return (value) => {
        if (!value || maxLength >= value.length || Object.getPrototypeOf(value) === Object.prototype) {
            return Promise.resolve(null);
        }
        return Promise.resolve({ maxLength: true });
    };
};
/**
 * Checks if a provided value is a number , returns {number:true} if not a number, return null if number
 * @param value Value to test
 */
const Number = (value) => {
    if (isNaN(value)) {
        return Promise.resolve({ number: true });
    }
    return Promise.resolve(null);
};
/**
 * Checks if a provided value is greater than a min value, returns {minValue:true} if too smaller.
 * @param value Value to test
 */
const MinValue = (minValue) => {
    return (value) => {
        if (isNaN(value) || value < minValue) {
            return Promise.resolve({ minValue: true });
        }
        return Promise.resolve(null);
    };
};
/**
 * Factory that returns a validator to test if value matches the provided pattern
 * Return {pattern:true} if no match,
 * @param value Value to test
 */
const Pattern = (regex) => {
    return (value) => {
        if (new RegExp(regex).test(value)) {
            return Promise.resolve(null);
        }
        return Promise.resolve({ pattern: true });
    };
};
const Email = (value) => {
    // if the value is empty, we don't return any error of email format
    // -> Use Required validator if you want to block empty value
    if (!value) {
        return Promise.resolve(null);
    }
    if (typeof value === 'string') {
        const match = value === null || value === void 0 ? void 0 : value.match(/(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/g);
        if (!match) {
            return Promise.resolve({ email: true });
        }
    }
    return Promise.resolve(null);
};
const Url = (value) => {
    // if the value is empty, we don't return any error of email format
    // -> Use Required validator if you want to block empty value
    if (!value) {
        return Promise.resolve(null);
    }
    if (typeof value === 'string') {
        try {
            new URL(value);
        }
        catch (_a) {
            return Promise.resolve({ url: true });
        }
    }
    return Promise.resolve(null);
};
const isEmptyValue = (value) => ((Array.isArray(value) || value instanceof Object) && (0, isEmpty_1.isEmpty)(value)) ||
    value == null ||
    (typeof value === 'string' && value.trim() === '');
exports.Validators = {
    Url,
    Email,
    Required,
    MinValue,
    MinLength,
    Number,
    Pattern,
    MaxLength,
};
